import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'MENU.MAIN',
    isTitle: true
  },
  // {
  //   label: 'MENU.DASHBOARD',
  //   icon: 'activity',
  //   link: '/dashboard'
  // },
  {
    label: 'MENU.MY_LECTURES',
    icon: 'calendar',
    link: '/lectures'
  },
  {
    label: 'MENU.FIND_LECTURE',
    icon: 'search',
    link: '/lectures/find-lecture'
  },
  // {
  //   label: 'MENU.COMPLETED_LECTURES',
  //   icon: 'check-circle',
  //   link: '/lectures/complete-lectures'
  // },
  {
    label: 'MENU.MANUAL_FEED',
    icon: 'edit',
    link: '/lectures/lecture-manual'
  },
  {
    label: 'ADMIN.ADMIN_AREA',
    isTitle: true,
    isAdmin: true
  },
  {
    label: 'ADMIN.DASHBOARD',
    icon: 'activity',
    link: '/admin/dashboard',
    isAdmin: true,
    isToggle: true,
    toggleKey: 'enableAdminDashboard'
  },
  {
    label: 'ADMIN.ALL_LECTURES',
    icon: 'calendar',
    link: '/admin/lectures',
    isAdmin: true
  },
  {
    label: 'ADMIN.ALL_USERS',
    icon: 'users',
    link: '/admin/users',
    isAdmin: true
  },
  // {
  //   label: 'ADMIN.REPORTS',
  //   icon: 'file-text',
  //   link: '/admin-reports',
  //   isAdmin: true
  // },
  {
    label: 'Theme Components',
    isTitle: true,
    isToggle: true,
    toggleKey: 'showThemeComponents'
  },
  {
    label: 'Dashboard',
    icon: 'home',
    link: '/dashboard',
    isToggle: true,
    toggleKey: 'showThemeComponents'
  },
  {
    label: 'Calendar',
    icon: 'calendar',
    link: '/apps/calendar',
    badge: {
      variant: 'primary',
      text: 'New',
    },
    isToggle: true,
    toggleKey: 'showThemeComponents'
  },
  {
    label: 'UI Kit',
    icon: 'feather',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'Alerts',
        link: '/ui-components/alerts',
      },
      {
        label: 'Badges',
        link: '/ui-components/badges',
      },
      {
        label: 'Breadcrumbs',
        link: '/ui-components/breadcrumbs',
      },
      {
        label: 'Buttons',
        link: '/ui-components/buttons',
      },
      {
        label: 'Button group',
        link: '/ui-components/button-group',
      },
      {
        label: 'Cards',
        link: '/ui-components/cards',
      },
      {
        label: 'Carousel',
        link: '/ui-components/carousel',
      },
      {
        label: 'Collapse',
        link: '/ui-components/collapse',
      },
      {
        label: 'Datepicker',
        link: '/ui-components/datepicker',
      },
      {
        label: 'Dropdowns',
        link: '/ui-components/dropdowns',
      },
      {
        label: 'List group',
        link: '/ui-components/list-group',
      },
      {
        label: 'Media object',
        link: '/ui-components/media-object',
      },
      {
        label: 'Modal',
        link: '/ui-components/modal',
      },
      {
        label: 'Navs',
        link: '/ui-components/navs',
      },
      {
        label: 'Navbar',
        link: '/ui-components/navbar',
      },
      {
        label: 'Pagination',
        link: '/ui-components/pagination',
      },
      {
        label: 'Popovers',
        link: '/ui-components/popovers',
      },
      {
        label: 'Progress',
        link: '/ui-components/progress',
      },
      {
        label: 'Rating',
        link: '/ui-components/rating',
      },
      {
        label: 'Scrollbar',
        link: '/ui-components/scrollbar',
      },
      {
        label: 'Spinners',
        link: '/ui-components/spinners',
      },
      {
        label: 'Timepicker',
        link: '/ui-components/timepicker',
      },
      {
        label: 'Tooltips',
        link: '/ui-components/tooltips',
      },
      {
        label: 'Typeadhed',
        link: '/ui-components/typeahead',
      },
    ]
  },
  {
    label: 'Advanced UI',
    icon: 'anchor',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'Cropper',
        link: '/advanced-ui/cropper',
      },
      {
        label: 'Owl carousel',
        link: '/advanced-ui/owl-carousel',
      },
      {
        label: 'Sweet alert',
        link: '/advanced-ui/sweet-alert',
      },
    ]
  },
  {
    label: 'Forms',
    icon: 'file-text',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'Basic elements',
        link: '/form-elements/basic-elements'
      },
      {
        label: 'Advanced elements',
        subItems: [
          {
            label: 'Form validation',
            link: '/advanced-form-elements/form-validation'
          },
          {
            label: 'Input mask',
            link: '/advanced-form-elements/input-mask'
          },
          {
            label: 'Ng-select',
            link: '/advanced-form-elements/ng-select'
          },
          {
            label: 'Ngx-chips',
            link: '/advanced-form-elements/ngx-chips'
          },
          {
            label: 'Ngx-color-picker',
            link: '/advanced-form-elements/ngx-color-picker'
          },
          {
            label: 'Ngx-dropzone',
            link: '/advanced-form-elements/ngx-dropzone-wrapper'
          },
        ]
      },
      {
        label: 'Editors',
        link: '/form-elements/editors'
      },
      {
        label: 'Wizard',
        link: '/form-elements/wizard'
      },
    ]
  },
  {
    label: 'Charts & graphs',
    icon: 'pie-chart',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'ApexCharts',
        link: '/charts-graphs/apexcharts',
      },
      {
        label: 'ChartJs',
        link: '/charts-graphs/chartjs',
      },
    ]
  },
  {
    label: 'Tables',
    icon: 'layout',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'Basic tables',
        link: '/tables/basic-table',
      }
    ]
  },
  {
    label: 'Icons',
    icon: 'smile',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'Feather icons',
        link: '/icons/feather-icons',
      },
      {
        label: 'Flag icons',
        link: '/icons/flag-icons',
      },
      {
        label: 'Mdi icons',
        link: '/icons/mdi-icons',
      }
    ]
  },
  {
    label: 'Special pages',
    icon: 'book',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: 'Blank page',
        link: '/general/blank-page',
      },
      {
        label: 'Faq',
        link: '/general/faq',
      },
      {
        label: 'Invoice',
        link: '/general/invoice',
      },
      {
        label: 'Profile',
        link: '/general/profile',
      },
      {
        label: 'Pricing',
        link: '/general/pricing',
      },
      {
        label: 'Timeline',
        link: '/general/timeline',
      }
    ]
  },
  {
    label: 'Error',
    icon: 'cloud-off',
    isToggle: true,
    toggleKey: 'showThemeComponents',
    subItems: [
      {
        label: '404',
        link: '/error/404',
      },
      {
        label: '500',
        link: '/error/500',
      },
    ]
  },
];
